import { useState, useCallback, useRef } from "react";

type Section = "topshop" | "topman";

interface LandingInteractionState {
  clicked: Section | null;
  hovered: Section | null;
  isNavigating: boolean;
  videoFinished: boolean;
}

export function useLogoInteraction() {
  const [state, setState] = useState<LandingInteractionState>({
    clicked: null,
    hovered: null,
    isNavigating: false,
    videoFinished: false,
  });

  const stateRef = useRef(state);
  stateRef.current = state;

  const setHovered = useCallback((value: Section | null) => {
    setState((prev) => ({ ...prev, hovered: value }));
  }, []);

  const setIsNavigating = useCallback((value: boolean) => {
    setState((prev) => ({ ...prev, isNavigating: value }));
  }, []);

  const setVideoFinished = useCallback((value: boolean) => {
    setState((prev) => ({ ...prev, videoFinished: value }));
  }, []);

  const handleSectionClick = useCallback(
    (target: Section, onNavigate?: (section: Section) => void) => {
      const currentState = stateRef.current;

      if (currentState.clicked || currentState.isNavigating) {
        return false;
      }

      setState((prevState) => ({
        ...prevState,
        clicked: target,
        hovered: null,
        isNavigating: true,
      }));

      // Call onNavigate after successful state update
      if (onNavigate) {
        onNavigate(target);
      }

      return true;
    },
    [],
  );

  return {
    state,
    setHovered,
    setIsNavigating,
    setVideoFinished,
    handleSectionClick,
  };
}
